module.exports = __webpack_public_path__ + "img/souvenier-3.e1c0369d.png";